import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
	AlertComponent,
	EmptyStateComponent,
	ModalComponent,
	TableComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { IFormMatchCompareTableRow } from '../../../../operations/utils/form-operation-match-compare.util';
import { IDocumentsCompareTableRow } from '../../../../shared/utils/documents-external-compare.util';
import { BOOLEAN_STATUS, IOperationDocument, IProcessDetailResponse } from '../../../models/processes.models';

/** Fila de comparación OCR vs AEAT (NIF-1095). */
export interface IAeatCompareTableRow {
	clickValue: string;
	notification: boolean;
	cells: Array<{ label: string }>;
}

@Component({
	selector: 'app-checks-modals',
	imports: [TranslatePipe, ModalComponent, AlertComponent, TableComponent, TileComponent, EmptyStateComponent],
	templateUrl: './checks-modals.component.html',
})
export class ChecksModalsComponent {
	private readonly translate = inject(TranslateService);

	@Input() detail: IProcessDetailResponse;
	@Input() showAeatModal = false;
	@Input() showMrzModal = false;
	@Input() showFormMatchModal = false;
	@Input() compareModalDoc: IOperationDocument | null = null;
	@Input() compareModalRows: IDocumentsCompareTableRow[] = [];
	@Input() compareModalHasMismatch = false;
	@Input() formMatchCompareRows: IFormMatchCompareTableRow[] = [];
	@Input() formMatchCompareHasMismatch = false;
	@Input() formMatchDataModalTitleKey = '';
	@Input() formMatchDataModalAlertKey = '';
	@Input() showMrzAlert = false;

	@Output() showAeatModalChange = new EventEmitter<boolean>();
	@Output() showMrzModalChange = new EventEmitter<boolean>();
	@Output() showFormMatchModalChange = new EventEmitter<boolean>();
	@Output() closeDocumentsCompare = new EventEmitter<void>();

	public BOOLEAN_STATUS = BOOLEAN_STATUS;

	/** Filas de cotejo OCR vs AEAT (name/surnames/identifier). `resultado` va en alert KO, no en tabla. */
	public aeatCompareRows(): IAeatCompareTableRow[] {
		const ocr = this.detail?.data?.OCR;
		const details = ocr?.actions?.AEAT?.details;
		if (!details) return [];

		const t = (key: string): string => this.translate.instant(key);
		return [
			{
				clickValue: '1',
				notification: ocr?.names !== details.name,
				cells: [
					{ label: t('PROCESSES.DETAIL.AEAT_MODAL.NAME') },
					{ label: ocr?.names ?? '' },
					{ label: details.name ?? '' },
				],
			},
			{
				clickValue: '2',
				notification: ocr?.surnames !== details.surname,
				cells: [
					{ label: t('PROCESSES.DETAIL.AEAT_MODAL.SURNAMES') },
					{ label: ocr?.surnames ?? '' },
					{ label: details.surname ?? '' },
				],
			},
			{
				clickValue: '3',
				notification: ocr?.identifier !== details.identifier,
				cells: [
					{ label: t('PROCESSES.DETAIL.AEAT_MODAL.ID') },
					{ label: ocr?.identifier ?? '' },
					{ label: details.identifier ?? '' },
				],
			},
		];
	}
}
